export const FILTER_TYPES = {
  'accesories': 'ACC',
  'spareparts': 'REP',
  'other': 'OTR',
};

export const COLORS = {
  'A0': '#593527',
  'A1': '#995A43',
  'A2': '#D9805F',
  'A3': '#BF7154',
  'A4': '#E68765',
  'A5': '#CC785A',
  'R0': '#385273',
  'R1': '#3F69A1',
  'R2': '#577FB3',
  'R3': '#6A9AD9',
  'R4': '#5E88BF',
  'R5': '#70A3E6',
  'R6': '#5176A6',
  'O0': '#233559',
  'O1': '#3C5B99',
  'O2': '#4B71BF',
  'O3': '#5A88E6',
  'O4': '#466AB3',
  'O5': '#4162A6',
  'letter': '#1A202D',
};
